export function createRulesDialogController(root) {
  const trigger = root.querySelector('[data-image-text-banner-rules-trigger]')
  const dialog = root.querySelector('[data-image-text-banner-rules-dialog]')
  const closeButton = root.querySelector('[data-image-text-banner-rules-close]')

  if (!trigger || !dialog || !closeButton) {
    return { disconnect() {} }
  }

  let returnFocus

  const handleOpen = () => {
    returnFocus = root.ownerDocument?.activeElement ?? trigger
    if (!dialog.open) dialog.showModal()
    trigger.setAttribute('aria-expanded', 'true')
  }

  const handleClose = () => {
    if (dialog.open) dialog.close()
  }

  const handleDialogClick = (event) => {
    if (event.target === dialog) handleClose()
  }

  const handleDialogClosed = () => {
    trigger.setAttribute('aria-expanded', 'false')
    returnFocus?.focus({ preventScroll: true })
    returnFocus = undefined
  }

  trigger.addEventListener('click', handleOpen)
  closeButton.addEventListener('click', handleClose)
  dialog.addEventListener('click', handleDialogClick)
  dialog.addEventListener('close', handleDialogClosed)

  return {
    disconnect() {
      trigger.removeEventListener('click', handleOpen)
      closeButton.removeEventListener('click', handleClose)
      dialog.removeEventListener('click', handleDialogClick)
      dialog.removeEventListener('close', handleDialogClosed)
      if (dialog.open) dialog.close()
      trigger.setAttribute('aria-expanded', 'false')
      returnFocus = undefined
    },
  }
}

if (
  typeof customElements !== 'undefined' &&
  typeof HTMLElement !== 'undefined' &&
  !customElements.get('image-text-banner')
) {
  customElements.define(
    'image-text-banner',
    class extends HTMLElement {
      connectedCallback() {
        this.rulesDialogController ??= createRulesDialogController(this)
      }

      disconnectedCallback() {
        this.rulesDialogController?.disconnect()
        this.rulesDialogController = undefined
      }
    },
  )
}
